import type { ISaleRepository } from '@/features/sale/domain/repositories/ISaleRepository.js';
import type { SaleEntity } from '@/features/sale/domain/entities/SaleEntity.js';
import type { SaleItemEntity, SaleReturnItemEntity } from '@/features/sale/domain/entities/SaleItemEntity.js';

export function createGetSaleDetailUseCase(deps: { saleRepository: ISaleRepository }) {
  return async function getSaleDetailUseCase(saleId: string): Promise<{ sale: SaleEntity; items: SaleItemEntity[]; returnItems: SaleReturnItemEntity[] }> {
    return deps.saleRepository.getSaleDetail(saleId);
  };
}

export type GetSaleDetailUseCase = ReturnType<typeof createGetSaleDetailUseCase>;
